// @flow

type State = {|
  segmentByLocations: boolean,
  segmentByGender: boolean,
  segmentByAge: boolean,
  segmentByProviders: boolean,
  segmentByFbPlacements: boolean,
  segmentByImportantParams: boolean,
  segmentByTargetingSources: boolean,
  segmentByVkApps: boolean,
  segmentByVkGroups: boolean,
  segmentByKeywords: boolean,
  segmentByVkActivity: boolean,
  segmentByInterests: boolean,
  segmentByPlatform: boolean,
  segmentByPlacementType: boolean
|}

type PatchAction = {|
  +type: 'SEGM.PATCH',
  +state: $Shape<State>
|}

export type { State }

const initialState: State = {
  segmentByLocations: false,
  segmentByGender: false,
  segmentByAge: false,
  segmentByProviders: false,
  segmentByFbPlacements: false,
  segmentByImportantParams: false,
  segmentByTargetingSources: false,
  segmentByVkApps: false,
  segmentByVkGroups: false,
  segmentByKeywords: false,
  segmentByVkActivity: false,
  segmentByInterests: false,
  segmentByPlatform: false,
  segmentByPlacementType: false
}

export function patch(diff: $Shape<State>): PatchAction {
  return {
    type: 'SEGM.PATCH',
    state: diff
  }
}

export default function reducer(state: State = initialState, action: PatchAction) {
  switch (action.type) {
    case 'SEGM.PATCH':
      return { ...state, ...action.state }
    default:
      return state
  }
}
